
export const viewImageByUrl = (urlList = [], opt = {}) => {
  let max = 1;
  for (const el of window.document.all) {
    const zIndex = ~~window.getComputedStyle(el)["zIndex"];
    max = Math.max(zIndex, max);
  }
  const asyncCom = require("@/CommonDP/commons/asyncCom").default;
  const ImageView = require("@/CommonDP/components/ImageView").default;
  return asyncCom(ImageView, {}, { urlList, zIndex: max + 1, ...opt });
};
export const isImgFileName = fileName => {
  return /.(jpe?g|png|bmp|gif|svg)$/i.test(fileName);
};
/**
 *
 * @param {Array} opt.imgsList:[{fileId:"",version:"",sharerId:""}]
 * @param {Array} opt.index
 * @returns
 */
export const viewImageIssueByUrl = (opt = {}) => {
  let max = 1;
  for (const el of window.document.all) {
    const zIndex = ~~window.getComputedStyle(el)["zIndex"];
    max = Math.max(zIndex, max);
  }
  const asyncCom = require("@/CommonDP/commons/asyncCom").default;
  const ImageView = require("@/CommonDP/components/ImageView/issue.vue").default;
  return asyncCom(ImageView, {}, { zIndex: max + 1, ...opt });
};
